module.exports = __webpack_public_path__ + "static/media/gif.d7012a55.gif";